import keyMirror from 'keymirror';
/* eslint-disable id-length */
export default keyMirror({
  MEMBERSHIP_SECTION_TITLE_REND: null,
  MEMBERSHIP_REQUEST_TITLE_REND: null,
  MEMBERSHIP_MESSAGE_REND: null,
  MEMBERSHIP_REQUEST_MSG_REND: null,
  MEMBERSHIP_EMAIL_INPUT_REND: null,
  MEMBERSHIP_REQUEST_EMAIL_REND: null,
  MEMBERSHIP_FRSTNAME_INPUT_REND: null,
  MEMBERSHIP_LASTNAME_INPUT_REND: null,
  MEMBERSHIP_SUBMIT_BTN_REND: null,
  MEMBERSHIP_REQUEST_SUBMIT_REND: null,
  MEMBERSHIP_EMAIL_FORM_REND: null,
  MEMBERSHIP_REQUEST_REND: null,
  MEMBERSHIP_FORM_REND: null,
  MEMBERSHIP_REQUEST_FORM_REND: null,
  MEMBERSHIP_EMAIL_ERR_REND: null,
  MEMBERSHIP_REQU_EMAIL_ERR_REND: null,
  MEMBERSHIP_REQU_FAIL_ERR_REND: null,
  MEMBERSHIP_FIRSTNAME_ERR_REND: null,
  MEMBERSHIP_LASTNAME_ERR_REND: null,
  MEMBERSHIP_REQUEST_ACCESS_REND: null,
  MEMBERSHIP_REQUEST_LINK_REND: null,
  PASSWORD_CREATE_TITLE_REND: null,
  PASSWORD_CREATE_FORM_REND: null,
  PASSWORD_CREATE_MESSAGE_REND: null,
  PASSWORD_CREATE_PW_INPUT_REND: null,
  PASSWORD_CREATE_PW_ERR_REND: null,
  PASSWORD_CREATE_CONFIRM_REND: null,
  PASSWORD_CONFIRM_ERR_REND: null,
  PASSWORD_CREATE_SUBMIT_REND: null,
  PASSWORD_CREATE_ERROR_REND: null,
  MEMBERSHIP_SSO_FORM_REND: null,
  MEMBERSHIP_SSO_TITLE_REND: null,
  MEMBERSHIP_SSO_MESSAGE_REND: null,
  MEMBERSHIP_SSO_LOGIN_EMAIL: null,
  MEMBERSHIP_SSO_LOGIN_PASSWORD: null,
  MEMBERSHIP_SSO_SUBMIT: null,
  MEMBERSHIP_SSO_ERR_REND: null,
  MEMBERSHIP_SSO_REQ_RESET: null,
  MEMBERSHIP_REQ_RESET_TITLE_REND: null,
  MEMBERSHIP_REQ_RESET_MESSAGE_REND: null,
  MEMBERSHIP_REQ_RESET_FORM_REND: null,
  MEMBERSHIP_REQ_RESET_EMAIL: null,
  MEMBERSHIP_REQ_RESET_SUBMIT: null,
  MEMBERSHIP_REQ_RESET_ERR_REND: null,
  MEMBERSHIP_REQ_RESET_CANCEL: null,
  MEMBERSHIP_PASS_RESET_TITLE_REND: null,
  MEMBERSHIP_PASS_RESET_MESSAGE_REND: null,
  MEMBERSHIP_PASS_RESET_FORM_REND: null,
  MEMBERSHIP_PASS_RESET_PASS: null,
  MEMBERSHIP_PASS_RESET_CONFIRM_PASS: null,
  MEMBERSHIP_PASS_RESET_SUBMIT: null,
  MEMBERSHIP_PASS_RESET_ERR_REND: null,
  MEMBERSHIP_SHOW_ACC: null,
  MEMBERSHIP_SHOW_BOOKINGS: null,
  MEMBERSHIP_SHOW_BOOKING_DETAILS: null,
  MEMBERSHIP_SHOW_ORDERS: null,
  MEMBERSHIP_PASS_EXPIRED_MESSAGE_REND: null,
  ACCOUNT_DETAILS_HEADING_REND: null,
  ACCOUNT_DETAILS_BOOKINGS_LINK_REND: null,
  ACCOUNT_DETAILS_ORDERS_LINK_REND: null,
  ACCOUNT_DETAILS_ACCOUNT_LINK_REND: null,
  ACCOUNT_DETAILS_NAME_REND: null,
  ACCOUNT_DETAILS_EMAIL_REND: null,
  ACCOUNT_DETAILS_PHONE_REND: null,
  ACCOUNT_DETAILS_EDIT_LINK_REND: null,
  NO_ACCESS_PAGE_REND: null,
  NO_ACCESS_HEADING_REND: null,
  NO_ACCESS_DESCRIPTION_REND: null,
  CREATE_ACCOUNT_REND: null,
  CREATE_ACCOUNT_HEADING_REND: null,
  CREATE_ACCOUNT_DESCRIPTION_REND: null,
  CREATE_ACCOUNT_FORM_REND: null,
  CREATE_ACCOUNT_NAME_FIRST: null,
  CREATE_ACCOUNT_NAME_LAST: null,
  CREATE_ACCOUNT_EMAIL: null,
  CREATE_ACCOUNT_PHONE: null,
  CREATE_ACCOUNT_BEACON: null,
  CREATE_ACCOUNT_NAME_FIRST_ERR: null,
  CREATE_ACCOUNT_NAME_LAST_ERR: null,
  CREATE_ACCOUNT_EMAIL_ERR: null,
  CREATE_ACCOUNT_PHONE_ERR: null,
  CREATE_ACCOUNT_MARKETING_CHECKBOX: null,
  EDIT_ACCOUNT_FORM_REND: null,
  EDIT_ACCOUNT_FIRST_NAME: null,
  EDIT_ACCOUNT_LAST_NAME: null,
  EDIT_ACCOUNT_PHONE: null,
  EDIT_ACCOUNT_FORM_ERR: null,
  ALERT: null,
  AUTH_REDIRECT: null,
  LOADING_LOADER_RENDERED: null
});
